import { useReveal } from "@/hooks/useReveal";

const CARDS = [
  {
    icon: "ri-rocket-2-line",
    title: "I am building my own brand",
    line: "A founder or brand manager who needs a certified co-packer willing to run small batches.",
    href: "#emerging-brands",
  },
  {
    icon: "ri-building-2-line",
    title: "I buy own brand for a retailer or distributor",
    line: "A category or own-brand buyer who needs a supplier that will not create audit or labelling problems.",
    href: "#own-brand",
  },
];

export default function TwoPathSplit() {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section id="split" className="bg-cream py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div ref={ref} className="reveal text-center max-w-2xl mx-auto">
          <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold">
            Two reasons people call us
          </h2>
          <p className="mt-3 text-ink/70 text-lg">
            Read the one that describes you. The terms are different.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
          {CARDS.map((card) => (
            <a
              key={card.title}
              href={card.href}
              className="group block bg-white rounded-lg p-7 md:p-9 border border-cream-dark/60 hover:border-brown/40 transition-colors"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-cream text-brown">
                <i className={`${card.icon} text-2xl`}></i>
              </div>
              <h3 className="mt-5 text-ink font-serif text-xl md:text-2xl font-semibold">
                {card.title}
              </h3>
              <p className="mt-2 text-ink/70 text-[17px] leading-relaxed">
                {card.line}
              </p>
              <span className="mt-5 inline-flex items-center gap-2 text-brand font-semibold text-sm">
                Read this
                <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1.5"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}